export default __webpack_public_path__ + "static/media/45_desktop.fe643155.jpg";